
import "./App.css";
import Layout from "./components/layout";
import Routers from "./routes";
import "react-toastify/dist/ReactToastify.css";
import { useEffect } from "react";
import { TOKEN_KEY } from "./config/variable";
import "react-loading-skeleton/dist/skeleton.css";


function App() {
  useEffect(() => {
    const isSavedInStorage =
      localStorage.getItem(TOKEN_KEY) || sessionStorage.getItem(TOKEN_KEY);

    if (!isSavedInStorage) {
      const urlParams = new URLSearchParams(window.location.search);
      const storageType = urlParams.get("storageType");
      const data = urlParams.get("data");

      if (data && data !== "undefined" && storageType) {
        try {
          const parsedData = JSON.parse(decodeURIComponent(data));

          if (storageType === "localStorage") {
            localStorage.setItem(TOKEN_KEY, JSON.stringify(parsedData));
          } else {
            sessionStorage.setItem(TOKEN_KEY, JSON.stringify(parsedData));
          }

          window.location.reload();
        } catch (error) {
          console.error("Failed to parse JSON data:", error);
        }
      } else {
        console.warn("Invalid data or storageType:", { data, storageType });
      }
      
    }
  }, []);

  return <Routers />;
}

export default App;
